import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import "core-js/modules/es.array.concat.js";
import { useMemo } from "react";
import { useLoggedOutContactUsContextStore } from "./LoggedOutContactUsContextStore";
export var useLoggedOutIssueType = function useLoggedOutIssueType() {
  var _useLoggedOutContactU = useLoggedOutContactUsContextStore(["issueL1", "issueL2", "issueL3"]),
    _useLoggedOutContactU2 = _slicedToArray(_useLoggedOutContactU, 1),
    _useLoggedOutContactU3 = _useLoggedOutContactU2[0],
    issueL1 = _useLoggedOutContactU3.issueL1,
    issueL2 = _useLoggedOutContactU3.issueL2,
    issueL3 = _useLoggedOutContactU3.issueL3;
  var issueType = useMemo(function () {
    if (issueL3) {
      return "".concat(issueL1, "-").concat(issueL2, "-").concat(issueL3);
    }
    if (issueL2) {
      return "".concat(issueL1, "-").concat(issueL2);
    }
    return issueL1 !== null && issueL1 !== void 0 ? issueL1 : "";
  }, [issueL1, issueL2, issueL3]);
  return {
    issueType: issueType
  };
};